import React from 'react';
import LogoAlpop from '../../../../../../resources/imgs/logo-alpop.png';
import Button from '../../../../../../components/Button';

const AlpopBanner: React.FC = () => {
  const handleOpenAlpopLink = () => {
    window.open(
      'https://materiais.ladobom.com/alpop-semfiador',
      '_blank',
      'noopener,noreferrer'
    );
  };
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <img src={LogoAlpop} />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'start'
        }}
      >
        <div style={{ fontWeight: 'bold', color: '#59249B', fontSize: '17px' }}>
          Análise recusada?
        </div>
        <div style={{ fontWeight: 'normal', fontSize: '14px' }}>
          Experimente a Alpop - Cobertura sem fiador e sem sinistro
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Button
          fluid
          type={'button'}
          size={'mini'}
          text="Saiba mais"
          style={{
            margin: '0.5em 0em',
            paddingLeft: '36px',
            paddingRight: '36px'
          }}
          onClick={() => handleOpenAlpopLink()}
        />
      </div>
    </>
  );
};

export default AlpopBanner;
